export const environment = {
  production: true,
  apiUrl: 'api',
  language: 'sv',
  supportedOs: ['mac', 'windows', 'ios', 'android'],
    testClinicId: '0000'
};
